import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import PageTitle from '../controls/PageTitle'
import LoadingStatus from '../controls/LoadingStatusContainer'
import TimeseriesDetailsView from './TimeseriesDetailsView'
import * as TimeseriesActionCreators from '../../actions/timeseries'

class TimeseriesDetailsPage extends React.Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    timeseries: PropTypes.object.isRequired,
    timeseriesActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      timeseries: state.timeseries,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      timeseriesActions: bindActionCreators(TimeseriesActionCreators, dispatch),
    }
  }

  componentDidMount() {
    this.fetchData()
  }

  componentDidUpdate() {
    this.fetchData()
  }

  fetchData = () => {
    const {
      timeseriesActions,
    } = this.props
    const tsId = this.timeseriesId()

    timeseriesActions.fetchTimeseries(tsId)
  }

  timeseriesId() {
    return parseInt(this.props.match.params.tsId, 10)
  }

  timeseries() {
    return this.props.timeseries[this.timeseriesId()] || {}
  }

  render() {
    return (
      <>
        <PageTitle title={this.timeseries().title} />
        <LoadingStatus blockContentUntilLoaded />
        <TimeseriesDetailsView timeseries={this.timeseries()} />
      </>
    )
  }
}

export default connect(
  TimeseriesDetailsPage.mapStateToProps,
  TimeseriesDetailsPage.mapDispatchToProps,
)(TimeseriesDetailsPage)
